import {
	Autocomplete,
	Box,
	Chip,
	Skeleton,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	TextField,
} from '@mui/material';
import { FC, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { AmountAndCurrency } from 'ui/AmountAndCurrency';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import {
	SwedBankIntegrationStatus,
	SwedBankSearchInvoicesPaymentStatus,
} from 'redux/reducers/swedBank/types';
import { searchInvoices, searchInvoicesLoad } from 'redux/reducers/swedBank/selectors';
import { nanoid } from '@reduxjs/toolkit';
import { TInvoicesTableTableProps } from './types';

const data1 = [
	{
		invoiceNumber: '123456',
		totalAmount: 23.19,
		em: 'SwissAir',
		paymentStatus: SwedBankIntegrationStatus.SKIPPED_STATUS,
	},
	{
		invoiceNumber: '1234567',
		totalAmount: 100.765,
		em: 'Nestle',
		paymentStatus: SwedBankIntegrationStatus.TO_BE_MANUALLY_PROCESSED_STATUS,
	},
	{
		invoiceNumber: '123458',
		totalAmount: 92.02,
		em: 'Zurich Bank',
		paymentStatus: SwedBankIntegrationStatus.SKIPPED_STATUS,
	},
	{
		invoiceNumber: '123459',
		totalAmount: 12.9,
		em: 'Swatch',
		paymentStatus: SwedBankIntegrationStatus.TO_BE_MANUALLY_PROCESSED_STATUS,
	},
	{
		invoiceNumber: '123460',
		totalAmount: 456.23,
		em: 'SwissAir',
		paymentStatus: SwedBankIntegrationStatus.SKIPPED_STATUS,
	},
];

export const InvoicesTableTable: FC<TInvoicesTableTableProps> = ({
	selectedInvoiceNumber,
	setSelectedInvoiceNumber,
}) => {
	// const confirmedOrder = useSelector(getConfirmedOrders);

	// const handleSelectRow = (id: string, easId: number) => {
	// 	setExternalId(id);
	// 	setEasId(easId);
	// };
	const data = useSelector(searchInvoices);
	const dataLoaded = useSelector(searchInvoicesLoad);

	return (
		<Box>
			{/* <Autocomplete
				options={data.map((invoice) => invoice.invoiceNumber)}
				renderInput={(params) => ( */}
			{/* )}
				value={data[0].invoiceNumber}
				onChange={() => {}}
				// inputValue={inputEm}
				// onInputChange={handleChangeEm}
			/> */}

			{data && data?.length > 0 && (
				<TableContainer
					sx={{
						overflowY: 'hidden',
						border: '1px solid #e0e0e0',
						borderRadius: '12px!important',
					}}
				>
					<Table sx={{ borderRadius: '12px', gap: 0 }}>
						<TableHead
							sx={{
								bgcolor: 'primary.main',
								borderRadius: '12px',
								'& th': {
									color: 'white',
									margin: 0,
									padding: '5px 10px',
								},
							}}
						>
							<TableRow>
								<TableCell>Invoice Number</TableCell>
								<TableCell>EM</TableCell>
								<TableCell align="right">Total Amount</TableCell>
								<TableCell align="left">Payment Status</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{!dataLoaded &&
								data &&
								data.length > 0 &&
								data?.map((invoice, index) => {
									return (
										<TableRow
											key={nanoid()}
											sx={{
												m: 0,
												p: 0,
												'&:hover': { bgcolor: '#bdd3df80' },
												cursor: 'pointer',
												bgcolor:
													selectedInvoiceNumber !== null && index === selectedInvoiceNumber
														? '#bdd3df'
														: '#fff',
											}}
											onClick={() => {
												setSelectedInvoiceNumber(index);
											}}
										>
											<TableCell
												sx={{
													m: 0,
													p: 1,
													overflow: 'hidden',
													textOverflow: 'ellipsis',
													whiteSpace: 'nowrap',
													maxWidth: '200px',
												}}
											>
												{invoice.invoiceNumber} <b>{invoice.invoiceReferenceNumber}</b>
											</TableCell>

											<TableCell
												sx={{
													m: 0,
													p: 1,
												}}
											>
												{invoice.emFullName}
											</TableCell>
											<TableCell
												align="right"
												sx={{
													m: 0,
													p: 1,
												}}
											>
												<AmountAndCurrency amount={invoice.amount} currency="EUR" />
											</TableCell>
											<TableCell
												align="left"
												sx={{
													m: 0,
													p: 1,
												}}
											>
												<Box>
													<Chip
														label={invoice.paymentStatus ?? 'Unknown'}
														size="small"
														sx={{
															p: '0 5px',
															fontSize: '.7rem',
															height: '20px',
															bgcolor:
																invoice.paymentStatus === SwedBankSearchInvoicesPaymentStatus.PAID
																	? 'success.light'
																	: invoice.paymentStatus ===
																		  SwedBankSearchInvoicesPaymentStatus.PARTIALLY_PAID
																		? 'warning.light'
																		: invoice.paymentStatus ===
																			  SwedBankSearchInvoicesPaymentStatus.PENDING
																			? 'info.light'
																			: invoice.paymentStatus ===
																				  SwedBankSearchInvoicesPaymentStatus.OVERDUE
																				? 'error.light'
																				: '#c5c5c5',
															color: '#00000090',
														}}
													/>
												</Box>
											</TableCell>
										</TableRow>
									);
								})}
							{/* {(confirmedOrder?.page.total ?? 0) > 6 && ( */}
							{!dataLoaded && data && data.length > 1 && (
								<TableRow>
									<TableCell
										sx={{
											height: '10px',
											m: '0',
											p: '0 20px',
											color: 'primary.main',
											fontSize: 0,
											borderBottom: 'none',
										}}
									>
										<MoreHorizIcon
											fontSize="large"
											sx={{
												p: 0,
												m: '-5px',
											}}
										/>
									</TableCell>
								</TableRow>
							)}
						</TableBody>
					</Table>
				</TableContainer>
			)}
			{!dataLoaded && data && data?.length === 0 && (
				<Box
					sx={{
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						height: '100px',
						color: 'primary.main',
						// fontWeight: 'bold',
					}}
				>
					No Invoices found
				</Box>
			)}
			{dataLoaded && (
				<Box
					sx={{
						pb: '1px',
					}}
				>
					{[1, 2, 3].map(() => (
						<Skeleton
							key={nanoid()}
							variant="rectangular"
							height="33px"
							sx={{
								mb: '33px',
							}}
						/>
					))}
				</Box>
			)}
		</Box>
	);
};
